import { EventEmitter } from "@angular/core";

export class IncorporadoraService{

    incorporadoraChanged = new EventEmitter<any>();

    public infoIncorporadora = {
        incorporadora:{
            id:0,
            nome:''
        },
        empreendimento:{
            id:0,
            nome:''
        },
        edificio:{
            id:0,
            nome:''
        },
        unidade:{
            id:0,
            nome:''
        },
    }

    getIncorporadora(){
        return this.infoIncorporadora;
    }
    addDados(key,value){
      
        this.infoIncorporadora[key].id = value.id;
        this.infoIncorporadora[key].nome = value.nome;
        this.incorporadoraChanged.emit(this.infoIncorporadora);

    }

}


// WEBPACK FOOTER //
// ./src/services/incorporadora.service.ts